import { useSyncExternalStore } from 'react'
import {
  getDeviceAccountsSnapshot,
  subscribeDeviceAccounts,
  type DeviceAccountsSnapshot,
} from './deviceAccountsStore'

const IDLE: DeviceAccountsSnapshot = { status: 'idle', ownerUserId: null, accounts: [], loadedAt: 0 }

/** Shared device-account list snapshot (see `deviceAccountsStore`). */
export function useDeviceAccounts(userId: string | undefined): DeviceAccountsSnapshot {
  const snap = useSyncExternalStore(subscribeDeviceAccounts, getDeviceAccountsSnapshot, getDeviceAccountsSnapshot)
  if (!userId || snap.ownerUserId !== userId) return IDLE
  return snap
}
